import { IBadgeGroupResponseDto } from '@core/gamefication/dto/badge-group/badge-group-response.dto';
import { useAppDispatch } from '@core/redux/hooks';
import {
  decreaseLoading,
  increaseLoading,
} from '@features/layout/store/layout.slice';
import { events } from '@service/api';
import { useState } from 'react';

interface BadgeGroupFilter {
  name?: string;
  competitionId?: number;
}

export const useBadgeGroup = () => {
  const dispatch = useAppDispatch();
  const [badgeGroupsList, setBadgeGroupList] =
    useState<IBadgeGroupResponseDto[]>();

  const getAllBadgeGroups = async (filter?: BadgeGroupFilter) => {
    try {
      dispatch(increaseLoading());
      const response = await events.getAllBadgeGroups(filter);
      setBadgeGroupList(response.rows);
    } catch (error) {
    } finally {
      dispatch(decreaseLoading());
    }
  };

  const filterBadgeGroups = (filter: BadgeGroupFilter) => {
    let filterProps: Record<string, any> = {
      name: filter.name
        ? { iLike: `$${filter.name.replace(' ', '$')}$` }
        : undefined,
    };
    if (!!filter.competitionId && filter.competitionId >= 0) {
      filterProps = {
        ...filterProps,
        competition: { id: filter.competitionId },
      };
    }
    getAllBadgeGroups(filterProps as BadgeGroupFilter);
  };

  return {
    getAllBadgeGroups,
    badgeGroupsList,

    filterBadgeGroups,
  };
};
